import { MIME_TYPES } from "@mantine/dropzone";
import React from "react";
import { File } from "react-feather";
import FileUploadField from "../../Form/FileUploadField";

function ApplicationFile({
  file,
  setFile,
  hasError,
}: {
  file?: File;
  setFile: (file?: File) => void;
  hasError: boolean;
}) {
  return (
    <FileUploadField
      label="Bewerbungsdatei"
      fileTypes={[MIME_TYPES.pdf, MIME_TYPES.docx, "text/plain"]}
      texts={{
        waiting: "Legen Sie Ihre Bewerbung hier ab",
        rejected: "Die Datei ist zu groß oder ungültig",
        accepted: "Die Datei wurde ausgewählt",
      }}
      file={file}
      setFile={setFile}
      hasError={hasError}
      required
    >
      Laden Sie Ihre Bewerbung hoch, um sie zu senden.
      <br />
      Bitte kombinieren Sie Ihre Dokumente in eine Datei und gehen Sie sicher,
      dass die Datei unter 30MB ist.
    </FileUploadField>
  );
}

export default ApplicationFile;
